module.exports = __webpack_public_path__ + "static/media/bottom_arrow_blue.7344a392.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/forum/bottom_arrow_blue.svg
// module id = ./src/assets/media/forum/bottom_arrow_blue.svg
// module chunks = 16